module.exports = __webpack_public_path__ + "static/img/r-5-2.3186611.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-5/r-5-2.png
// module id = PFGo
// module chunks = 0